// utils/slugAliases.ts — Resolver slug lama -> slug baru (anti URL mati).
// Dipakai viewer publik saat slug tidak ketemu: cek tabel slug_aliases
// (ditulis otomatis oleh trigger DB tiap slug berubah), lalu redirect.
// Pure-ish: hanya baca via RPC publik (anon boleh).
import { supabase } from '../supabase/client';

export type SlugAliasKind = 'form' | 'landing_page' | 'digital_product' | 'ai_lp';

/**
 * Resolve rantai alias: slug lama -> slug terbaru (maks 5 hop, anti-siklus).
 * Return slug baru bila beda dari input, null bila tidak ada alias.
 */
export async function resolveSlugAlias(
    kind: SlugAliasKind,
    slug: string,
    maxHops = 5,
): Promise<string | null> {
    let cur = String(slug || '').trim();
    if (!cur) return null;
    const seen = new Set<string>([cur.toLowerCase()]);
    for (let i = 0; i < maxHops; i++) {
        let next: unknown = null;
        try {
            const { data, error } = await supabase.rpc('resolve_slug_alias', {
                p_kind: kind,
                p_slug: cur,
            });
            if (!error && typeof data === 'string' && data.trim()) next = data.trim();
        } catch {
            return null;
        }
        if (!next || seen.has((next as string).toLowerCase())) {
            return cur.toLowerCase() === slug.toLowerCase() ? null : cur;
        }
        cur = next as string;
        seen.add(cur.toLowerCase());
    }
    return cur.toLowerCase() === String(slug).toLowerCase() ? null : cur;
}
